import { Component, inject, Renderer2, signal } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { ApiService, AuthService, AuthToken } from '@solcre-org/core';
import { DOCUMENT } from '@angular/common';
import {
  AlertService,
  AlertType,
  ButtonType,
  DynamicFieldDirective,
  FieldType,
  LayoutAuth,
  ModalFieldConfig,
  ModalMode,
} from '@solcre-org/core-ui';
import { HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../../../environments/environment.local';
import { AuthLogin } from './auth-login.interface';

@Component({
  selector: 'app-login',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TranslateModule,
    RouterModule,
    LayoutAuth,
    DynamicFieldDirective,
  ],
  templateUrl: './login.html',
})
export class Login {
  private router: Router = inject(Router);
  private formBuilder: FormBuilder = inject(FormBuilder);
  private authService: AuthService = inject(AuthService);
  private apiService: ApiService = inject(ApiService);
  private renderer: Renderer2 = inject(Renderer2);
  private document: Document = inject(DOCUMENT);
  private alertService: AlertService = inject(AlertService);

  FieldType = FieldType;
  ModalMode = ModalMode;
  ButtonType = ButtonType;
  loading = signal<boolean>(false);
  environment = environment;

  config: any = {
    mainLogoUrl: '/assets/images/logo_blanco.svg',
  };
  authFields: ModalFieldConfig<any>[] = [
    {
      key: 'username',
      type: FieldType.TEXT,
      label: 'login.username',
      placeholder: 'login.usernamePlaceholder',
      prefixIcon: 'icon-user',
      validators: [Validators.required],
      readonly: false,
    },
    {
      key: 'password',
      type: FieldType.PASSWORD,
      label: 'login.password',
      placeholder: 'login.passwordPlaceholder',
      prefixIcon: 'icon-locked',
      validators: [Validators.required],
      readonly: false,
    },
  ];
  model: AuthLogin = {};

  ngOnInit(): void {
    this.renderer.addClass(this.document.documentElement, 'page-styles');
    this.renderer.addClass(this.document.documentElement, 'is-onboarding');
  }

  ngOnDestroy(): void {
    this.renderer.removeClass(this.document.documentElement, 'page-styles');
    this.renderer.removeClass(this.document.documentElement, 'is-onboarding');
  }

  onFieldValueChange(fieldKey: string, value: string): void {
    this.model[fieldKey] = value;
  }

  onFormSubmit() {
    if (!this.model.username || !this.model.password) {
      return;
    }

    let username = this.model.username;
    let password = this.model.password;

    this.loading.set(true);
    this.authService.login(username, password).subscribe({
      next: (response: any) => {
        if (response) {
          const userData = this.authService.getLoggedStartData();

          const token: AuthToken | null = this.authService.getAccessToken();
          if (token) {
            this.apiService.setAccessToken(
              this.authService.getAccessToken()?.token!
            );
            this.router.navigate([environment.STATES.AUTHENTICATED]);
          } else {
            this.alertService.show({
              type: AlertType.ERROR,
              message: `errors.genericLogin`,
              duration: 5000,
              inBottom: true,
            });
          }
          this.loading.set(false);
        }
      },
      error: (error: HttpErrorResponse) => {
        const errorMessage: string = `errors.${error.status === 401 ? 'invalidCredentials' : 'genericLogin'
          }`;

        this.alertService.show({
          type: AlertType.ERROR,
          message: errorMessage,
          duration: 5000,
          inBottom: true,
        });
        this.loading.set(false);
      },
    });
  }
}
